import React from "react"
import { css } from "styled-components"
import Text, { RichText } from "../../atoms/text"
import VariantContainer, { IStyleVariant } from "../../atoms/variant-container"
import { T } from "../../styles/typography"
import mergeVariants from "../../util/merge-variants"
import { FeatureCardContainer } from "./feature-card.style"

export interface IFeature {
  icon: string
  title: string
  text: string | React.ReactNode
}

interface IFeatureCardProps {
  featureDetails: IFeature
  className?: string
  headlineLayoutVariants?: IStyleVariant | any[]
  titleVariants?: IStyleVariant | any[]
  textVariants?: IStyleVariant | any[]
  iconVariants?: IStyleVariant | any[]
  titleTag?: string
}

const FeatureCard = ({
  featureDetails,
  className,
  headlineLayoutVariants,
  titleVariants,
  textVariants,
  iconVariants,
  titleTag = "h3",
}: IFeatureCardProps) => (
  <FeatureCardContainer className={className}>
    <VariantContainer
      variants={mergeVariants(
        [
          css`
            display: flex;
            flex-direction: column;
            align-items: center;
          `,
          css`
            flex-direction: row;
            justify-content: center;
          `,
          css`
            justify-content: flex-start;
          `,
        ],
        headlineLayoutVariants
      )}
    >
      <VariantContainer
        src={featureDetails.icon}
        alt=" "
        variants={mergeVariants(
          [
            css`
              max-height: 40px;
              max-width: 40px;
              object-fit: contain;
            `,
            css`
              margin-right: 16px;
            `,
            css`
              max-height: 48px;
              max-width: 48px;
            `,
          ],
          iconVariants
        )}
        as="img"
      />
      <Text
        as={titleTag}
        variants={mergeVariants(
          {
            sm: css`
              margin-top: 24px;
              color: var(--dark-mode-body-grey);
              ${T.sm.h3(500)}
            `,
            md: css`
              margin-top: 0px;
              ${T.md.h4(500)}
            `,
            lg: css`
              ${T.lg.h4(400)}
              line-height: 120%;
            `,
          },
          titleVariants
        )}
      >
        {featureDetails.title}
      </Text>
    </VariantContainer>
    <Text.Body
      variants={mergeVariants(
        {
          sm: css`
            margin-top: 16px;
            color: var(--dark-mode-body-grey);
          `,
        },
        textVariants
      )}
    >
      {featureDetails.text}
    </Text.Body>
  </FeatureCardContainer>
)

FeatureCard.DarkText = ({
  featureDetails,
  titleVariants,
  textVariants,
  ...rest
}: IFeatureCardProps) => {
  return (
    <FeatureCard
      featureDetails={featureDetails}
      titleVariants={mergeVariants(
        {
          sm: css`
            color: var(--slate);
          `,
        },
        titleVariants
      )}
      textVariants={mergeVariants(
        {
          sm: css`
            color: var(--body-text-grey);
          `,
        },
        textVariants
      )}
      {...rest}
    />
  )
}

export default FeatureCard
